import React from 'react';
import styled from 'styled-components';

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
`;

const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none; /* Prevent interaction */
  user-select: none; /* Prevent selection */
  -webkit-user-select: none; /* For Safari */
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(2, 30, 54, 0.7); /* Semi-transparent overlay using #021E36 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  text-align: center;
  padding: 0 1rem;
`;

const VideoBackground = ({ children }) => {
  return (
    <VideoContainer>
      <Video 
        autoPlay 
        loop 
        muted 
        playsInline // Important for iOS
        webkit-playsinline="true" // For older iOS versions
        preload="auto"
        disablePictureInPicture // Prevent picture-in-picture
        controls={false}
      >
        <source src="/stockvideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </Video>
      <Overlay>
        {children}
      </Overlay>
    </VideoContainer>
  );
};

export default VideoBackground; 